import { LayoutService } from '@/app/layout/service/layout.service';
import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        @for (item of model; track $index) {
            @if (!item.separator) {
                <li app-menuitem [item]="item" [root]="true"></li>
            } @else {
                <li class="menu-separator"></li>
            }
        }
    </ul> `
})
export class AppMenu {
    model: any[] = [
        { label: 'Dashboard', icon: 'pi pi-chart-bar', routerLink: ['/notifications'] },
        { separator: true },
        {
            label: 'Notificações',
            icon: 'pi pi-bell',
            path: '/notifications',
            items: [
                { label: 'Regras', icon: 'pi pi-cog', routerLink: ['/notifications/rules'] },
                { label: 'Eventos', icon: 'pi pi-list', routerLink: ['/notifications/events'] },
                { label: 'Inbox', icon: 'pi pi-inbox', routerLink: ['/notifications/inbox'] },
                { label: 'Simulador', icon: 'pi pi-sliders-v', routerLink: ['/notifications/simulator'] },
                { label: 'Swap Simulator', icon: 'pi pi-sync', routerLink: ['/notifications/swap-simulator'] },
            ]
        },
        { separator: true },
        {
            label: 'Admin',
            icon: 'pi pi-shield',
            path: '/admin',
            items: [
                { label: 'Campos de Notificação', icon: 'pi pi-list-check', routerLink: ['/admin/fields'] },
                { label: 'Config Agent Swap', icon: 'pi pi-sliders-h', routerLink: ['/admin/swap-config'] },
                { label: 'Conjuntos de Regras', icon: 'pi pi-list-check', routerLink: ['/admin/rule-sets'] },
                { label: 'Agendamento Swap', icon: 'pi pi-clock', routerLink: ['/admin/schedule-config'] },
                { label: 'Equipamentos', icon: 'pi pi-box', routerLink: ['/admin/equipments'] },
                { label: 'Tipos de Equipamento', icon: 'pi pi-tags', routerLink: ['/admin/equipments-type'] },
                { label: 'Modelos de IA', icon: 'pi pi-microchip-ai', routerLink: ['/admin/ai-models'] },
                { label: 'Config de Geração', icon: 'pi pi-sliders-h', routerLink: ['/admin/global-settings'] },
                { label: 'Cena', icon: 'pi pi-image', routerLink: ['/admin/scene'] },
                { label: 'Smart Creator', icon: 'pi pi-sparkles', routerLink: ['/admin/smart-creator'] },
                { label: 'Biblioteca', icon: 'pi pi-images', routerLink: ['/admin/biblioteca'] },
            ]
        },
    ];
}
